import { CampaignLanding } from "~/components/site/campaign-landing";
import { campaignForPath, GOOGLE_ADS } from "~/data/campaigns";
import { buildMarketingMeta } from "~/lib/seo/route-meta";
import { breadcrumbJsonLd, SITE_URL } from "~/lib/seo/jsonld";
import type { Route } from "./+types/_marketing.campaign";

export const meta: Route.MetaFunction = ({ data }) => {
  const campaign = data?.campaign ?? GOOGLE_ADS;
  return buildMarketingMeta({ pathname: campaign.path, title: campaign.title, description: campaign.description,
    image: `${SITE_URL}${campaign.image.desktop}`,
    extraAfter: [{ "script:ld+json": breadcrumbJsonLd([{ name: "Home", url: "/" }, { name: campaign.title.split(" | ")[0], url: campaign.path }]) }],
  });
};

export function loader({ request }: Route.LoaderArgs) {
  const campaign = campaignForPath(new URL(request.url).pathname.replace(/\.data$/, ""));
  if (!campaign) throw new Response("Not found", { status: 404 });
  return { campaign };
}

export async function action({ request }: Route.ActionArgs) {
  const { submitProject } = await import("~/lib/project-submission.server");
  return submitProject(request);
}

export default function Campaign({ loaderData, actionData }: Route.ComponentProps) {
  return <CampaignLanding campaign={loaderData.campaign} actionData={actionData} />;
}
